import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormErrorMessageService } from 'src/app/shared/services/form-error-message.service';
import { DropdownEventType, FormField } from 'src/app/shared/interfaces/form-fields';
import { FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface FilterSelectChangeEvent {
  controlName: string;
  event: DropdownEventType;
}

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit, OnDestroy {

  @Input() formGroup: FormGroup;
  @Input() formFields: FormField[];
  @Input() searchText: string;
  @Input() searchTextPlaceholder: string;
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() clearFormEvent = new EventEmitter<any>();
  @Output() selectChangeEvent = new EventEmitter<FilterSelectChangeEvent>();
  @Output() filterTableEvent = new EventEmitter<any>();
  isDropdown = false;

  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  constructor(
    private formErrorService: FormErrorMessageService
  ) { }

  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      this.searchTextChange.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  trackByFieldName(index: number, field: FormField): string {
    return field.name;
  }

  toggleDropdown() {
    this.isDropdown = !this.isDropdown;
  }

  closeDropdown() {
    this.isDropdown = false;
  }

  onSearchChange(): void {
    this.searchSubject.next(this.searchText);
  }

  // When user press enter key
  onEnterPressed(): void {
    if (this.searchText.trim() !== '') {
      this.searchTextChange.emit(this.searchText);
    }
  }
  
  handleSelectChange(event: DropdownEventType, controlName: string) { 
    this.selectChangeEvent.emit({ controlName, event });
  }

  filterTable() {
    this.filterTableEvent.emit(this.formGroup.value);
    this.closeDropdown();
  }

  clearForm() {
    this.formGroup.reset();
    this.filterTable();
  }

  getErrorMessage(controlName: string, labelName: string): string {
    const control = this.formGroup.get(controlName);
    const errors = control?.errors;
    return this.formErrorService.getErrorMessage(errors, labelName); 
  }

}
